'use client';

import PropTypes from 'prop-types';
import {getThumbnailUrl} from "@/utils/image-utils.ts";

import Box from "@mui/material/Box";

import Image from "src/components/image";
import Lightbox, {useLightBox} from "src/components/lightbox";

function RecipeStepsGallery({stepPhotos, ...other}) {
  const photos = [];

  stepPhotos?.forEach(stepPhoto => {
    const photoData = {src: getThumbnailUrl(stepPhoto, 'strona')};

    const stepDataThumbnailUrl = getThumbnailUrl(stepPhoto, '350_350');
    if (stepDataThumbnailUrl) {
      photoData.src_mini = stepDataThumbnailUrl;
    }

    photos.push(photoData);
  });

  const {
    selected: selectedImage,
    open: openLightbox,
    onOpen: handleOpenLightbox,
    onClose: handleCloseLightbox,
  } = useLightBox(photos);

  if (photos.length < 1) {
    return '';
  }

  return (
    <>
      <Box
        {...other}
        gap={1}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          lg: 'repeat(4, 1fr)',
        }}
      >
        {photos.map((photo) => (
          <Image
            key={photo.src}
            alt={photo.src}
            src={photo.src_mini}
            ratio="1/1"
            onClick={() => handleOpenLightbox(photo.src)}
            sx={{borderRadius: 2, cursor: 'pointer'}}
          />
        ))}
      </Box>

      <Lightbox
        index={selectedImage}
        slides={photos}
        open={openLightbox}
        close={handleCloseLightbox}
        disabledCaptions
        disabledSlideshow
        disabledFullscreen
        disabledZoom
      />
    </>
  );
}

RecipeStepsGallery.propTypes = {
  stepPhotos: PropTypes.array
};

export default RecipeStepsGallery;
